import axios from 'axios'

const baseUrl = 'https://api.mobilize.us/v1/events'

export default class Mobilize {
  constructor() {
    this.baseUrl = baseUrl
  }

  /**
   * @description Get first page of mobilize data
   * @param params
   * @return {Promise<*>} Array of records
   */
  async getPreviewData(params) {
    const { data: response } = await axios.get(this.baseUrl, {
      params
    })
    return response.data
  }

  /**
   * @description Get all mobilize data
   * @param params
   * @return {Promise<[]>} Array of records
   */
  async get(params) {
    let data = []
    async function getData(url, params) {
      const { data: response } = await axios.get(url, {
        params
      })
      // eslint-disable-next-line no-unused-vars
      const { next, data: chunk } = response
      data = [...data, ...chunk]
      return true
      // return next ? getData(next, {}) : true
    }
    await getData(this.baseUrl, params)
    return data
  }
}
